/* eslint-disable no-lone-blocks */

import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate, useParams } from 'react-router-dom'
import userService from '../../../../Services/userService'
import './PhysicalScreening.scss'
import ImageUploader from './ImageUpload/imageUpload'
import BasicInfo from './BasicInformation/BasicInfo'
import NextOfKin from './NextOfKin/NextOfKin'
// import AddressState from './Address_n_State_of_Origin/Address_n_State'
import { MentalEvaluation } from '../../Components'
// import ResidentialAddress from './ResidentialAddress/ResidentialAddress'
import { Loader } from '../../../../Components'
import toast, { Toaster } from 'react-hot-toast'
import { ErrorHandler } from '../../../../Helpers/ErrorHandler'
import applicantsService from '../../../../Services/applicantsService'

const ApplicantProfile = () => {
  const { nin } = useParams()
  console.log('refid', nin)
  const [values, setValues] = useState<any>({})

  const [data, setData] = useState([{ name: '', value: '' }])
  const [submit, setSubmit] = useState<boolean>(false)

  const { register, handleSubmit, setValue, formState: { errors } } = useForm()

  const navigate = useNavigate()

  const handleChange = (e: { target: { name: any; value: any; }; }) => {
    const { name, value } = e.target
    console.log({ name, value })

    setData({
      ...data,
      [name]: value
    })
  }

  const [loader, setLoader] = useState(false)

  async function getData () {
    setLoader(true)

    await userService.getDataSingle(nin).then((res: any) => {
      setLoader(false)
      console.log('DANGER GGDDGGDGG SHOW RAW', res.data)
      setValues({ photo: res.data.photo, ...res.data.dataset.nimc, ...res.data.metadata, ...res.data.dataset.formData })
    }, (error: any) => {
      setLoader(false)
      console.log('DANGER ERROR dd', error)
      if (error.response.data.display === 'exception') {
        toast.error(error?.response?.data?.message, { duration: 20000, className: 'bg-danger text-white' })
      }
      ErrorHandler(error,
        () => {
          toast.error(error?.response?.data?.message, { duration: 20000, className: 'bg-danger text-white' })
        })
    })
  }

  useEffect(() => {
    if (nin) {
      getData()
    }
  }, [nin])

  const onSubmit = handleSubmit(async (formData, e) => {
    e?.preventDefault()
    console.log('medicalData', data)
    setSubmit(true)
    try {
      const res = await applicantsService.submitPScreening({ ...formData, nin })
      console.log(res)
      toast.success('SUBMITTED SUCCESSFULLY', { duration: 20000, className: 'bg-success text-white' })
      navigate('/dashboard/', { replace: true })
    } catch (error: any) {
      console.log(error)
      toast.error(error.response.data.message || 'An error occurred', { duration: 20000, className: 'bg-danger text-white' })
    } finally {
      setSubmit(false)
    }
  })

  useEffect(() => {
    setValue('firstname', values.firstname)
    setValue('middlename', values.middlename)
    setValue('surname', values.surname)
    setValue('dob', values.dob)
    setValue('age', values.age)
    setValue('email', values.email)
    setValue('mobile', values.phone)
    setValue('mobile1', values.phone1)
    setValue('nextOfKinName', values.nextOfKinName)
    setValue('nextOfKinPhone', values.nextOfKinPhone)
    setValue('nextOfKinEmail', values.nextOfKinEmail)
    setValue('nextOfKinGender', values.nextOfKinGender)
    setValue('nextOfKinRelationship', values.nextOfKinRelationship)
    setValue('streetAddressOfPermanent', values?.streetAddressOfPermanent)
    setValue('stateOfPermanent', values?.stateOfPermanent)
    setValue('lgaOfPermanent', values?.lgaOfPermanent)
    setValue('streetAddressOfPermanent', values?.streetAddressOfPermanent)
    setValue('stateOfPermanent', values?.stateOfPermanent)
    setValue('lgaOfPermanent', values?.lgaOfPermanent)
    setValue('streetAddressOfResidence', values?.residence_AdressLine1)
    setValue('stateOfResidence', values?.residence_state)
    setValue('lgaOfResidence', values?.residence_lga)
  }, [values])

  console.log('CLOSUREEEEEE', values)
  return (
    <div className="applicant-physicalScreening container-lg">
      <div className="card shadow-sm rounded mt-4">
        <div className="applicant-profile container-lg">
          <form action="">
            <div className="card shadow-sm mt-4">
              <div className="card-body">
                <div className="container-fluid">
                  <ImageUploader register={register} values={{ photo: values.photo, firstname: values.firstname, middlename: values.middlename, surname: values.surname, nin: values.nin }} />
                </div>
              </div>
            </div>

            <BasicInfo register={register} errors={errors} handleChange={handleChange} values={values} />

            <div className="card card-user-profile-modal shadow-sm border bg-light rounded my-4">
              <div className="card-header bg-warning">
                <h5 className="text-dark w-bolder">Next Of Kin Record</h5>
              </div>
              <div className="card-body bg-white">
                <NextOfKin register={register} errors={errors} handleChange={handleChange} values={values} />
              </div>
            </div>
            <MentalEvaluation register={register} errors={errors} handleChange={handleChange}></MentalEvaluation>

            <div className="card card-user-profile-modal bg-white shadow-sm">
              <div className="card-body text-center">

                {!submit
                  ? (<button type='submit' className='btn btn-lg submit-button text-dark bg-warning fs-5' onClick={onSubmit}>Submit </button>)
                  : (<button type="submit" className="btn btn-lg submit-button text-dark bg-warning fs-5" disabled>
                    Please <div className="spinner-border spinner-border-sm" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </button>)}
              </div>
            </div>
          </form>
        </div>
      </div>
      <Toaster></Toaster>
      <Loader show={loader}></Loader>
    </div>
  )
}

export default ApplicantProfile

// eslint-disable-next-line no-lone-blocks
{ /* <div className="card card-user-profile-modal bg-white shadow-sm">
                        <div className="card-header bg--secondary">
                            <h5 className="text-light fw-bolder">Address & State Of Origin</h5>
                        </div>
                        <div className="card-body">
                        <AddressState register={register} errors={errors} handleChange={handleChange} data={data}/>
                        </div>
                    </div> */ }

{ /* <div className="card card-user-profile-modal bg-white shadow-sm">
                        <div className="card-header bg--secondary">
                                <h5 className='text-light'>Residential Address</h5>
                            </div>
                            <div className="card-body">
                                <ResidentialAddress register={register} errors={errors} handleChange={handleChange} values={values} data={data}/>
                            </div>
                        </div> */ }
{ /* <div className="card card-user-profile-modal bg-white shadow-sm">
                        <div className="card-header bg-warning">
                            <h5 className='text-dark'>ICT Proficency Evaluation</h5>
                        </div>
                        <div className="card-body">
                            <ICTProficiency register={register} errors={errors} handleChange={handleChange}/>
                        </div>
                    </div> */ }

{ /* <SsceFirstSitting register={register} errors={errors} handleChange={handleChange}></SsceFirstSitting> */ }
